import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    card: {
      display: "flex",
      flexDirection: "row",
      backgroundColor: theme.goal.harvest.taxFiling.background,
      borderRadius: constants.radius.view,
      padding: spacing.m,
    },
    iconColumn: {
      alignItems: "flex-start",
      display: "flex",
      marginRight: spacing.xs,
      paddingTop: spacing.xxxs,
    },
    content: {
      flex: 1,
    },
    title: {
      color: theme.text.secondary,
      fontWeight: 500,
    },
    body: {
      color: theme.text.secondary,
      lineHeight: "14px",
    },
    disclaimer: {
      color: theme.text.secondary,
      fontStyle: "italic",
      lineHeight: "12px",
      fontWeight: 400,
    },
  };

  return { styles, iconFill: theme.text.secondary };
};
